export class CNPJUtils {
    static invalidCNPJs: string[] = [
        "00000000000000",
        "11111111111111",
        "22222222222222",
        "33333333333333",
        "44444444444444",
        "55555555555555",
        "66666666666666",
        "77777777777777",
        "88888888888888",
        "99999999999999"
    ];

    public static ValidarCNPJ(cnpj: string): boolean {
        if (!cnpj) return false;

        cnpj = cnpj.trim();
        cnpj = cnpj.split(".").join("").split("-").join("").split("/").join("");
        if (cnpj.length != 14) return false;
        const multiplicador1: number[] = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const multiplicador2: number[] = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        let soma: number;
        let resto: number;
        let digito: string;
        let tempCnpj: string;
        if (CNPJUtils.invalidCNPJs.includes(cnpj)) {
            return false;
        }
        tempCnpj = cnpj.substring(0, 12);
        soma = 0;
        for (var i = 0; i < 12; i++) soma += Number(tempCnpj[i]) * multiplicador1[i];

        resto = soma % 11;

        if (resto < 2) resto = 0;
        else resto = 11 - resto;

        digito = resto.toString();
        tempCnpj = tempCnpj + digito;
        soma = 0;

        for (var i = 0; i < 13; i++) soma += Number(tempCnpj[i].toString()) * multiplicador2[i];

        resto = soma % 11;

        if (resto < 2) resto = 0;
        else resto = 11 - resto;

        digito = digito + resto.toString();

        return cnpj.endsWith(digito);
    }
}
